import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { LeadArchiveDialogComponent } from './lead-archive-dialog/lead-archive-dialog.component';
import { LeadAttachmentsComponent } from './lead-attachments/lead-attachments.component';
import { LeadDetailDialogComponent } from './lead-detail-dialog/lead-detail-dialog.component';
import { LeadPostponeDialogComponent } from './lead-postpone-dialog/lead-postpone-dialog.component';
import { LeadsListPage } from './list/list.page';

export const leadsRoutes: Routes = [
	{ path: '', component: LeadsListPage, canActivate: [AuthGuard] },
];

@NgModule({
	imports: [],
	exports: [RouterModule]
})
export class LeadsRoutingModule {
	public static components = [
		LeadsListPage,
		LeadAttachmentsComponent,
		LeadDetailDialogComponent,
		LeadPostponeDialogComponent,
		LeadArchiveDialogComponent,
	];
}
